import { BoxSelectIcon, CaseUpperIcon, CodeIcon, FormInputIcon, HeadingIcon, ImageIcon, LayoutPanelTopIcon, LinkIcon, MenuIcon, SparkleIcon, SquareIcon, } from "lucide-react";
import { DraggableComponentTypes } from "../../types/draggable";
export const draggableCategories = {
    structure: "Structuur",
    basic: "Basis",
    typography: "Teksten",
    media: "Media",
    form: "Formulieren",
    navigator: "Navigatie",
    // other: "Overig",
};
export const draggableElements = [
    {
        type: DraggableComponentTypes.Text,
        element: "P",
        name: "Tekst",
        icon: CaseUpperIcon,
        category: draggableCategories.typography,
    },
    {
        type: DraggableComponentTypes.Title,
        element: "h1",
        name: "H1",
        icon: HeadingIcon,
        category: draggableCategories.typography,
    },
    {
        type: DraggableComponentTypes.Div,
        element: "div",
        name: "Div",
        icon: BoxSelectIcon,
        category: draggableCategories.structure,
    },
    {
        type: DraggableComponentTypes.Grid,
        element: "grid",
        name: "Grid",
        icon: LayoutPanelTopIcon,
        category: draggableCategories.structure,
    },
    {
        type: DraggableComponentTypes.Image,
        element: "img",
        name: "Afbeelding",
        icon: ImageIcon,
        category: draggableCategories.media,
    },
    {
        type: DraggableComponentTypes.Link,
        element: "A",
        name: "Link",
        icon: LinkIcon,
        category: draggableCategories.basic,
    },
    {
        type: DraggableComponentTypes.Button,
        element: "button",
        name: "Button",
        icon: SquareIcon,
        category: draggableCategories.basic,
    },
    {
        type: DraggableComponentTypes.Form,
        element: "form",
        name: "Formulier",
        icon: FormInputIcon,
        category: draggableCategories.form,
    },
    {
        type: DraggableComponentTypes.Navbar,
        element: "navbar",
        name: "Navigatie",
        icon: MenuIcon,
        category: draggableCategories.navigator,
    },
    {
        type: DraggableComponentTypes.NavbarVertical,
        element: "navbarVariant",
        name: "Menu vertical",
        icon: MenuIcon,
        category: draggableCategories.navigator,
    },
    {
        type: DraggableComponentTypes.Html,
        element: "html",
        name: "HTML",
        icon: CodeIcon,
        category: draggableCategories.basic,
    },
    {
        type: DraggableComponentTypes.Container,
        element: "container",
        name: "Container",
        icon: BoxSelectIcon,
        category: draggableCategories.structure,
    },
    {
        type: DraggableComponentTypes.Icon,
        element: "icon",
        name: "Icon",
        icon: SparkleIcon,
        category: draggableCategories.basic,
    },
];
//# sourceMappingURL=draggableElements.js.map